import axios from 'axios'
import qs from 'qs'
Vue.axios = axios


import {
    Ads,
    AnalystInfo,
    ArticleList,
    DynamicList,
    SalonList,
    PraiseDynamic,
    SymbolList,
    FollowAnalyst,
    AccountList,
    AskAnalyst
} from './address.js'

var instance = axios.create({
    withCredentials:true,
    crossDomain: true
})

export default {
     /**
     * 获取广告列表
     */
     getAds: function(){
         return axios.post(Ads);
     },
     /**
     * 获取分析师信息
     */
     getAnalystInfo: function(){
         return axios.get(AnalystInfo);
     },
     /**
     * 获取分析师文章列表
     * @param page 页码 默认为1
     * @param analyst 分析师id
     */

     getAllArticleList: function (params){
         return axios.post(ArticleList, qs.stringify(params));
     },
     /**
     * 获取分析师动态列表
     * @param page 页码 默认为1
     * @param analyst 分析师id
     */
     getAllDynamicList: function (params){
         return axios.post(DynamicList, qs.stringify(params));
         // return axios.get(DynamicList);
     },
     /**
     * 获取分析师沙龙列表
     * @param page 页码 默认为1
     * @param analyst 分析师id
     */
     getAllSalonList: function(params){
         return axios.post(SalonList, qs.stringify(params));
         // return axios.get(SalonList);
     },
     /**
     * 分析师动态点赞
     * @param id 动态id
     */
     praiseDynamic: function(params){
         return axios.post(PraiseDynamic, qs.stringify(params));
     },
     /**
     * 行情列表
     * @param groupId 0-常用 1-黄金 2-外汇 3指数 4-全部
     */
     getSymbolList: function(params){
         return instance.post(SymbolList, qs.stringify(params));

     },
     /**
     * 关注分析师
     * @param analystId 分析师id
     */
     followAnalyst: function(params){
         return axios.post(FollowAnalyst, qs.stringify(params));
     },
     /**
     * 获取账户列表
     */
     getAccountList: function(){
         return instance.post(AccountList);
     },
     /**
     * 沙龙分析师一对一提问
     * @param analystId 分析师id
     * @param question 问题内容
     */
     askAnalyst: function(params){
         return axios.post(AskAnalyst, qs.stringify(params));
     }



}



// WEBPACK FOOTER //
// ./src/service/analyst/api/index.js